import { Image } from "expo-image";
import { memo } from "react";

type Props = {
	uri: string | null | undefined;
	size?: number;
};

const ProfileIcon = ({ uri, size = 24 }: Props) => {
	if (!uri) {
		return null;
	}

	return (
		<Image
			cachePolicy="memory-disk"
			source={{
				uri: uri,
				width: size,
			}}
			// * This fixes the flickering of image on web
			placeholder={{
				uri: uri,
				width: size,
			}}
			style={{
				borderRadius: 6,
				width: size,
				height: size,
			}}
		/>
	);
};

export default memo(ProfileIcon);
